<template>
  <section
    class="AccountLayout"
    data-theme="light"
  >
    <TabNav v-bind="{ navItems }" />

    <RouterView />
  </section>
</template>

<script lang="ts" setup>
import TabNav from "@/components/TabNav.vue";
import { RouteName } from "@/lib/router/routes";
import { ref } from "vue";

const navItems = ref([
  {
    label: "Profile",
    route: {
      name: RouteName.profile,
    },
  },
  {
    label: "Achievements",
    route: {
      name: RouteName.achievements,
    },
  },
  {
    label: "Settings",
    route: {
      name: RouteName.settings,
    },
  },
]);
</script>

<style lang="scss" scoped>
.AccountLayout {
  display: grid;
  grid: min-content auto / auto;
  height: 100%;

  background-color: var(--themeColorNeutral0);
}
</style>
